import {
  BI_BASE_API_URL,
  BI_GET_CONSOLIDATED_TOTALIZERS_ENDPOINT,
  BI_GET_CONSOLIDATED_INDICATORS_ENDPOINT,
  BI_GET_EVOLUTIVE_INDICATORS_ENDPOINT,
  BI_GET_LOGIN_TOTALIZER_ENDPOINT,
} from '../constants/indicatorsConstants';
import httpService from './httpService';

const indicatorsService = () => {
  // GET -  Obtém  dados dos totalizadores consolidados
  const getConsolidatedTotalizers = async ({ selectedYear, selectedPatientGroup }) => {
    const { get } = httpService();
    const params = null;

    const result = await get({
      url: `${BI_BASE_API_URL + BI_GET_CONSOLIDATED_TOTALIZERS_ENDPOINT}/?year=${selectedYear}&patientGroupItemCode=${selectedPatientGroup}`,
      data: params,
    });

    return result;
  };

  // GET -  Obtém  dados dos totalizadores consolidados
  const getConsolidatedIndicators = async ({ selectedYear, selectedPatientGroup }) => {
    const { get } = httpService();
    const params = null;

    const result = await get({
      url: `${BI_BASE_API_URL + BI_GET_CONSOLIDATED_INDICATORS_ENDPOINT}/?year=${selectedYear}&patientGroupItemCode=${selectedPatientGroup}`,
      data: params,
    });

    return result;
  };

  // GET -  Obtém  dados dos totalizadores consolidados
  const getEvolutiveIndicators = async ({ selectedPatientGroup, selectedIndicator }) => {
    const { get } = httpService();
    const params = null;

    const result = await get({
      url: `${BI_BASE_API_URL + BI_GET_EVOLUTIVE_INDICATORS_ENDPOINT}/?patientGroupItemCode=${selectedPatientGroup}&indicator=${selectedIndicator}`,
      data: params,
    });

    return result;
  };

  // GET -  Obtém  dados dos totalizadores da tela inicial
  const getLoginTotalizer = async () => {
    const { get } = httpService();
    const params = null;

    const result = await get({
      url: `${BI_BASE_API_URL + BI_GET_LOGIN_TOTALIZER_ENDPOINT}`,
      data: params,
    });

    return result;
  };

  return {
    getConsolidatedTotalizers,
    getConsolidatedIndicators,
    getEvolutiveIndicators,
    getLoginTotalizer,
  };
};

export default indicatorsService;
